import { render } from "./video-recommend.vue?vue&type=template&id=10c857d4&scoped=true"
import script from "./video-recommend.vue?vue&type=script&lang=js"
export * from "./video-recommend.vue?vue&type=script&lang=js"

import "./video-recommend.vue?vue&type=style&index=0&id=10c857d4&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c857d4"]])

export default __exports__